// v2.4 CARD PROJECTION — pure helpers to compute the final damage/block a card would deal
// against the current combat state (accounting for STR, WEAK, VULN, multipliers, blessDoubleStr).
// Used by the hover tooltip in Combat.jsx. Does NOT mutate state.

export function projectCardDamage(card, state) {
  if (!card || card.type !== 'attack' || typeof card.damage !== 'number') return null;
  let base = card.damage + (state.player.strength || 0);
  if (state.player._blessMods && state.player._blessMods.blessDoubleStr) {
    base += (state.player.strength || 0);
  }
  if (card.damageEqualsBlock) base += (state.player.block || 0);
  if (card.damageEqualsEnergy) base += (state.player.energy || 0);
  // Weak → 25% less outgoing
  const weak = state.player.weak || 0;
  let dmg = weak > 0 ? Math.floor(base * 0.75) : base;
  // Vuln on enemy → 50% more incoming
  if ((state.enemy.vulnerable || 0) > 0) dmg = Math.floor(dmg * 1.5);
  // Multi-hit (if present, we still show per-hit; user can multiply mentally)
  return { perHit: dmg, hits: card.hits || 1, total: dmg * (card.hits || 1) };
}

export function projectCardBlock(card, state) {
  if (!card || typeof card.block !== 'number') return null;
  let b = card.block + (state.player.dexterity || 0);
  // FRAIL → 25% less block
  if ((state.player.frail || 0) > 0) b = Math.floor(b * 0.75);
  return b;
}

// Format a compact preview label for the tooltip: e.g. "9×3 = 27" or "18" or "BLK +12"
export function projectionLabel(card, state) {
  const parts = [];
  const dmg = projectCardDamage(card, state);
  if (dmg) {
    if (dmg.hits > 1) parts.push(`${dmg.perHit}×${dmg.hits} = ${dmg.total}`);
    else parts.push(`${dmg.total} DMG`);
  }
  const blk = projectCardBlock(card, state);
  if (blk !== null && blk > 0) parts.push(`+${blk} BLK`);
  return parts.join(' · ');
}
